import { Flex, styled, Text } from '@shared/components';

import { ItemSetContentPreviewer } from '../item-set-content-previewer';
import { MockRadioButtonIcon } from '../mock-radio-button-icon';
import { QuestionContentPreviewer } from '../question-content-previewer';

const DetailsWrapper = styled(Flex)(({ theme }) => ({
  borderRadius: theme.shape.rounded(2),
  padding: theme.spacing(4),
  gap: theme.spacing(3),
  backgroundColor: theme.palette.grey[100],
  flexDirection: 'column',
}));

const ChoicesListItemWrapper = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(4),
  gap: theme.spacing(3),
  justifyContent: 'center',
  alignItems: 'flex-start',
}));

export interface PreviewItemSetQuestionProps {
  itemSetId: string;
  questionId: string;
  paragraph: string;
  totalQuestions: number;
  question: string;
  choices: Array<{
    label: string;
    order: number;
    isCorrect: boolean;
  }>;
}

export default function PreviewItemSetQuestion(props: Readonly<PreviewItemSetQuestionProps>) {
  const { itemSetId, questionId, paragraph, totalQuestions, question, choices } = props;
  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(4),
        flexDirection: 'column',
        width: '100%',
        height: '100%',
      })}
    >
      <DetailsWrapper sx={(theme) => ({ padding: theme.spacing(4), gap: theme.spacing(3) })}>
        <Text variant='h5'>โจทย์สำหรับคำถามข้อ 1 - {totalQuestions}</Text>
        <ItemSetContentPreviewer itemSetId={itemSetId} content={paragraph} />
      </DetailsWrapper>
      <DetailsWrapper>
        <Text variant='h5'>คำถาม</Text>
        <QuestionContentPreviewer questionId={questionId} content={question} />
      </DetailsWrapper>
      <Flex sx={{ flexDirection: 'column' }}>
        {choices.map((choice, index) => (
          <ChoicesListItemWrapper key={index}>
            <MockRadioButtonIcon selected={choice.isCorrect} />
            <Text sx={{ flexShrink: 0 }}>{choice.order}.</Text>
            <QuestionContentPreviewer questionId={questionId} content={choice.label} />
          </ChoicesListItemWrapper>
        ))}
      </Flex>
    </Flex>
  );
}
